<template>
  <v-main>
    <v-container fluid>
      <router-view :key="$route.path" />
      <v-footer />
    </v-container>
    <update-app-massage />
  </v-main>
</template>

<script>
  import vFooter from '@/components/kitchen/footer/Footer'
  import UpdateAppMassage from '@/components/UpdateAppMassage.vue'

  export default {
    name: 'KitchenLayout',
    components: {
      UpdateAppMassage,
      vFooter,
    },
    created () {
      this.$store.commit('app/hideFloatingButtons')
    },
  }
</script>
